import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage, FormattedDate } from 'react-intl';
import { withRouter } from 'react-router';
import { withUrlGenerator } from '@folklore/react-app';
import Helmet from 'react-helmet';
import moment from 'moment';

import Blocks from '../blocks/Blocks';
import SocialButtons from '../partials/SocialButtons';

import { setPage as setPageActions } from '../../actions/SiteActions';

import styles from '../../../styles/pages/post.scss';

const propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func,
    }).isRequired,
    slug: PropTypes.string,
    page: PropTypes.shape({
        data: PropTypes.shape({
            blocks: PropTypes.array,
        }),
    }),
    urlGenerator: PropTypes.shape({
        route: PropTypes.func,
    }).isRequired,
    news: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
    })),
    setPage: PropTypes.func.isRequired,
};

const defaultProps = {
    slug: null,
    page: null,
    news: null,
};

class Post extends PureComponent {
    constructor(props) {
        super(props);

        this.onPageLoaded = this.onPageLoaded.bind(this);
    }

    componentDidMount() {
        const { page } = this.props;
        if (page === null) {
            this.fetchPage();
        }
    }

    onPageLoaded(page) {
        this.props.setPage(page);
    }

    fetchPage() {
        const { urlGenerator, slug } = this.props;
        fetch(`${urlGenerator.route('api.page')}?slug=${slug}`)
            .then(response => response.json())
            .then(this.onPageLoaded);
    }

    render() {
        const { intl, page } = this.props;
        const createdAt = get(page, 'created_at', null);
        const date =
            createdAt !== null ? moment(createdAt, 'YYYY-MM-DD HH:mm:ss').toDate() : new Date();
        return (
            <div className={styles.container}>
                <Helmet>
                    <title>
                        {intl.formatMessage(
                            {
                                id: 'meta.title_news',
                                defaultMessage: 'Accueil',
                            },
                            {
                                title: get(page, 'title', ''),
                            },
                        )}
                    </title>
                </Helmet>
                <div
                    className={classNames({
                        [styles.section]: true,
                        [styles.header]: true,
                    })}
                >
                    <div className={styles.cols}>
                        <div
                            className={classNames({
                                [styles.col]: true,
                                [styles.colTitle]: true,
                            })}
                        >
                            <h1 className={styles.title}>
                                <FormattedMessage id="content.news" defaultMessage="News" />
                            </h1>
                        </div>
                    </div>
                </div>
                <div
                    className={classNames({
                        [styles.section]: true,
                        [styles.content]: true,
                    })}
                >
                    <div className={styles.cols}>
                        <div
                            className={classNames({
                                [styles.col]: true,
                                [styles.colDate]: true,
                            })}
                        >
                            <span className={styles.inner}>
                                <div className={styles.date}>
                                    <div className={styles.number}>
                                        <FormattedDate value={date} day="numeric" />
                                    </div>
                                    <div className={styles.month}>
                                        <FormattedDate value={date} month="long" />
                                    </div>
                                    <div className={styles.year}>
                                        <FormattedDate value={date} year="numeric" />
                                    </div>
                                </div>

                                <div className={styles.social}>
                                    <SocialButtons url={get(page, 'url', '')} />
                                </div>
                            </span>
                        </div>
                        <div
                            className={classNames({
                                [styles.col]: true,
                                [styles.colContent]: true,
                            })}
                        >
                            <h1 className={styles.title}>{get(page, 'title', null)}</h1>

                            <div className={styles.blocks}>
                                <Blocks
                                    items={get(page, 'data.blocks', []).map((block, index) => ({
                                        ...block,
                                        first: index === 0,
                                    }))}
                                    className={styles.block}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Post.propTypes = propTypes;
Post.defaultProps = defaultProps;

const mapStateToProps = ({ site, layout }, { location, match }) => ({
    ...layout.size,
    news: site.news,
    slug: (match.params || {}).slug,
    page:
        site.page !== null && site.page.url === location.pathname
            ? site.page
            : (site.news || []).find(it => it.url === location.pathname) || null,
});
const mapDispatchToProps = dispatch => ({
    setPage: page => dispatch(setPageActions(page)),
});
const WithStateContainer = connect(mapStateToProps, mapDispatchToProps)(Post);
const WithIntlContainer = injectIntl(WithStateContainer);
const WithRouterContainer = withRouter(WithIntlContainer);
const WithUrlGeneratorContainer = withUrlGenerator()(WithRouterContainer);

export default WithUrlGeneratorContainer;



// WEBPACK FOOTER //
// ./js/components/pages/Post.jsx